import { container } from 'tsyringe';
import { ModelManager } from '@/prototyping/model';
import { JsonRpcModule, JsonRpcNotifyHandler } from '../../jrpc/module';

export class ARModule extends JsonRpcModule {
  async enableAr(enabled: boolean): Promise<boolean> {
    return this.channel.call('AR.EnableAr', [enabled]);
  }

  async resetTracking(): Promise<void> {
    return this.channel.call('AR.ResetTracking', []);
  }

  @JsonRpcNotifyHandler('trackingLost')
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  trackingLost(): void {}

  async enableImageTracking(enabled: boolean): Promise<boolean> {
    return this.channel.call('AR.EnableImageTracking', [enabled]);
  }

  @JsonRpcNotifyHandler('foundImageTarget')
  foundImageTarget(name: string): void {
    const modelManager = container.resolve(ModelManager);
    const audioPlayer = modelManager.get('audio-player', 'AudioPlayerModel');
    const imageTargetTracks = modelManager.get('image-target-tracks', 'StoryblokImageTargetTracksLibModel');
    const vinylpostcards = modelManager.get('vinylpostcards', 'VinylPostcardsModel');
    const audioLib = modelManager.get('audio-lib', 'StoryblokAudioLibModel');
    vinylpostcards.stopAudioPlayerAndAddNewSongsFromImageTarget(name, audioPlayer, audioLib, imageTargetTracks);
  }

  async resetScanner(): Promise<void> {
    return this.channel.call('AR.ResetScanner', []);
  }

  async enableManualPlacement(enabled: boolean): Promise<boolean> {
    return this.channel.call('AR.EnableManualPlacement', [enabled]);
  }

  async setObject(objectName: string): Promise<void> {
    return this.channel.call('AR.SetObject', [objectName]);
  }

  async placeObject(): Promise<void> {
    return this.channel.call('AR.PlaceObject', []);
  }

  async removeObject(): Promise<void> {
    return this.channel.call('AR.RemoveObject', []);
  }

  @JsonRpcNotifyHandler('planeDetected')
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  planeDetected(): void {}

  @JsonRpcNotifyHandler('placeholderEnabled')
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  placeholderEnabled(enabled: boolean): void {}

  @JsonRpcNotifyHandler('objectPlaced')
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  objectPlaced(): void {}

  @JsonRpcNotifyHandler('objectRemoved')
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  objectRemoved(): void {}
}
